//This file is generated from c# do not modify, any changes will be overridden when re-generated.
  import { ModelBase } from "../../pillar/common/models/ModelBase";
  
  import { PhysicalAddressModel } from './../../common/models/PhysicalAddressModel';
  import { DataSetAccessModel } from './DataSetAccessModel';
  import { ContactModel } from './ContactModel';
  import { SubmittingEntityIdentifierModel } from "./SubmittingEntityIdentifierModel";
  
  export class SubmittingEntityModel extends ModelBase {
      static readonly $typeName = 'SubmittingEntityModel';
      public addresses: PhysicalAddressModel[];
      public allowedDataSets: DataSetAccessModel[];
      public contacts: ContactModel[];
      public name: string;
      public isReportingConfigured: boolean;
      public autoGenerateSftpXmlJobReports: boolean;
      public identifiers: SubmittingEntityIdentifierModel[];
  }



// WEBPACK FOOTER //
// ./src/app/submission/models/SubmittingEntityModel.ts